export enum FileCategory {
  Admin = 1,
  AirOpsPlan = 2,
  AirspaceAuthorization = 3,
  CampPendletonTAR = 4,
  CongestedAreaPlan = 5,
  EnvironmentalCulturalRestrictions = 6,
  FlightArea = 7,
  LandManagementApproval = 8,
  LandingZone = 9,
  LiftPlan = 10,
  SafetyMitigations = 11,
  SensitiveCustomer = 12,
  ShortHaulHEC = 13,
  Special = 14,
  Structure = 15,
  PublicSafetyConcerns = 17,
}
